import { render, staticRenderFns } from "./IncomingCallComponent.vue?vue&type=template&id=51b4ef19&"
import script from "./IncomingCallComponent.vue?vue&type=script&lang=ts&"
export * from "./IncomingCallComponent.vue?vue&type=script&lang=ts&"
import style0 from "./IncomingCallComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports